import { axiosInstance } from "../core/axios-interceptors";
import { getBaseUrl } from "../core/config";
import { Client } from "../generated/api-client";

export class AppClient {
  private static _instance: Client;
  public static version = "1.0";

  public static getInstance(): Client {
    if (!AppClient._instance) {
      AppClient._instance = new Client(getBaseUrl(), axiosInstance);
    }
    return AppClient._instance;
  }
}
